import styled from '@emotion/styled';
import noUserIcon from 'ui/images/no-user-icon.svg';

interface ImgProps {
    size?: number;
    disabled?: boolean;
    border?: boolean;
}
const Img = styled.img`
    width: ${(props: ImgProps) => `${props.size}px`};
    height: ${(props: ImgProps) => `${props.size}px`};
    border-radius: 200px;
    background-color: var(--white);
    object-fit: cover;
    object-position: center;
    opacity: ${(props: ImgProps) => (props.disabled ? 0.5 : 1)};
    border: ${(props: ImgProps) => (props.border ? '1px solid #000' : 'none')};
`;

const NoUserImg = styled.img`
    width: ${(props: ImgProps) => `${props.size}px`};
    height: ${(props: ImgProps) => `${props.size}px`};
    border-radius: 200px;
    background-color: #626262;
    border: ${(props: ImgProps) => (props.border ? '1px solid #000' : 'none')};
`;

interface Props {
    src?: string | null;
    alt?: string;
    size?: number; // px
    isActive?: boolean;
    disabled?: boolean;
    border?: boolean;
}

/**
 * ユーザーアイコンコンポーネント
 */
export const UserIcon: React.FC<Props> = ({
    src,
    alt = 'ユーザーアイコン',
    size = 34,
    isActive = true,
    disabled,
    border,
}) => {
    let img;
    if (src && isActive) {
        img = src;
    } else {
        return <NoUserImg src={noUserIcon} alt={alt} size={size} border={border} />;
    }
    return <Img src={img} alt={alt} size={size} disabled={disabled} border={border} />;
};
